export const alertEvents = [
  {
    label: 'PAC',
    desc: 'PAC 1 switch to PAC 2',
    color: 'cyan',
  },
  {
    label: 'HVAC',
    desc: 'HVAC operation manual',
    color: 'blue',
  },
  {
    label: 'PL',
    desc: 'Lift P1 under maintenance',
    color: 'orange',
  },
  {
    label: 'GS',
    desc: 'Genset 2 Switched Off',
    color: 'red',
  },
  {
    label: 'TRF',
    desc: 'Trafo high temperature',
    color: 'green',
  },
];

export const activityLog = [
  {
    label: '08.15',
    desc: 'Ers Jevi input LVDP voltage',
  },
  {
    label: '09.11',
    desc: 'Fathudin change status PL 1',
  },
  {
    label: '11.17',
    desc: 'Maulana is doing the preventif',
  },
  {
    label: '13.24',
    desc: 'Syarif switched PAC1 tp stdb',
  },
  {
    label: '15.10',
    desc: 'Sai is doing preventif P. Fan',
  },
];

const chartOptions = {
  chart: {
    width: '100%',
    height: 50,
    foreColor: "#fff",
    // sparkline: {
    //   enabled: true,
    // },
    toolbar:{
      show: false,
    },
  },
  legend: {
    show: false,
  },
  stroke: {
    curve: 'smooth',
    width: 3,
  },
  xaxis: {
    type: "category"
  },
  tooltip: {
    theme: 'dark',
    fixed: {
      enabled: false,
    },
    x: {
      show: true,
    },
    y: {
      title: {
        formatter: function (seriesName) {
          return seriesName;
        },
      },
      formatter: (value) => {
        return value;
      },
    },
    marker: {
      show: true,
    },
  },
}

export const lvdpVoltageChart = {
  options: {
    ...chartOptions,
    colors: ['#55ffff', '#ff00ff', '#9900ff'],
  },
  series: [
    {
      name: "Phase 1",
      data: [
        {x: "2017", y: 20},
        {x: "2018", y: 30},
        {x: "2019", y: 40},
        {x: "2020", y: 50}
      ],
    },
    {
      name: "Phase 2",
      data: [
        {x: "2017", y: 27},
        {x: "2018", y: 32},
        {x: "2019", y: 38},
        {x: "2020", y: 22}
      ],
    },
    {
      name: "Phase 3",
      data: [
        {x: "2017", y: 30},
        {x: "2018", y: 35},
        {x: "2019", y: 40},
        {x: "2020", y: 25}
      ],
    },
  ],
};

export const electricityConsumptionChart = {
  options: {
    ...chartOptions,
    colors: ['#99ff99', '#ffff00'],
  },
  series: [
    {
      name: "Phase 1",
      type: "line",
      data: [
        {x: "2017", y: 37},
        {x: "2018", y: 30},
        {x: "2019", y: 50},
        {x: "2020", y: 50}
      ],
    },
    {
      name: "Phase 2",
      type: "area",
      data: [
        {x: "2017", y: 27},
        {x: "2018", y: 25},
        {x: "2019", y: 30},
        {x: "2020", y: 33}
      ],
    },
  ],
}

export const gensetTimeCycleChart = {
  options: {
    ...chartOptions,
    colors: ['#0000ff', '#ff0000'],
  },
  series: [
    {
      name: "Genset 1",
      data: [
        {x: "2019", y: 25},
        {x: "2020", y: 50}
      ],
    },
    {
      name: "Genset 2",
      data: [
        {x: "2019", y: 36},
        {x: "2020", y: 35}
      ],
    },
  ],
}

export const elevatorPerformanceChart = {
  options: {
    ...chartOptions,
    colors: ['#ffaa00', '#ff0000', '#1ab7ea', '#0084ff'],
    labels: ["PL1", "PL2", "PL3", "SL"],
    plotOptions: {
      radialBar: {
        offsetX: -10,
        startAngle: -225,
        endAngle: 30,
        hollow: {
          margin: 1,
          size: '10%',
          background: 'transparent',
          image: undefined,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          }
        }
      }
    },
    legend: {
      show: true,
      floating: true,
      position: 'right',
      offsetX: 10,
      offsetY: 40,
      labels: {
        useSeriesColors: true,
      },
      // markers: {
      //   size: 0
      // },
      formatter: function(seriesName, opts) {
        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
      },
      itemMargin: {
        horizontal: 1,
      }
    }
  },
  series: [65, 51, 63, 72],
}

export const maintenanceChart2 = {
  options: {
    ...chartOptions,
    plotOptions: {
      bar: {
        distributed: true
      }
    },
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return val + "%";
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val + "%";
      },
    },
    tooltip: {
      theme: 'dark',
      fixed: {
        enabled: false,
      },
      y: {
        title: {
          formatter: function (seriesName) {
            return "";
          },
        },
        formatter: (value) => {
          return value + "%";
        },
      },
      marker: {
        show: true,
      },
    },
  },
  series: [{
    data: [
      {x: "Fire AI. System", y: 20},
      {x: "P.Fan", y: 40},
      {x: "Genset", y: 30},
      {x: "CCTV", y: 50},
  ],
  }],
}

export const maintenanceChart = {
  options: {
    ...chartOptions,
    // colors: ['#0000ff', '#ff0000'],
  },
  series: [
    {
      name: "Planning",
      data: [
        {x: "Mingguan", y: 0},
        {x: "Bulanan", y: 0},
        {x: "Tahunan", y: 0},
      ],
    },
    {
      name: "Actual",
      data: [
        {x: "Mingguan", y: 0},
        {x: "Bulanan", y: 0},
        {x: "Tahunan", y: 0}
      ],
    },
    {
      name: "Verification",
      data: [
        {x: "Mingguan", y: 0},
        {x: "Bulanan", y: 0},
        {x: "Tahunan", y: 0},
      ],
    },
  ],
}